import { Layout } from 'react-admin';
import { AppBar } from './appbar/AppBar';

import { MyMenu } from './MyMenu';

export const MyLayout = props => <Layout {...props} menu={MyMenu} appBar={AppBar} />;